<template>
  <div class="setting">
    <ul>
      <li>
        <div class="info-item">
          <div class="name ellispsis">
            {{ code }}
          </div>
          <div class="rule ellispsis">
            {{ info.tenantCode }}
          </div>
        </div>
      </li>
      <li>
        <div class="info-item">
          <div class="name ellispsis">
            {{ name }}
          </div>
          <div class="rule ellispsis">
            {{ info.tenantName }}
          </div>
        </div>
      </li>
      <li>
        <div class="info-item">
          <div class="name ellispsis">
            {{ $t('page_personal_expires_time') }}
          </div>
          <div class="rule time">
            {{ info.expireTime | dayjs('YYYY-MM-DD HH:mm:ss') }}
          </div>
        </div>
        <div class="action">
          <div class="time">
            {{ expiredText }}
          </div>
          <a-button type="primary" @click="()=>contactVisible = true">
            {{ $t('page_personal_contact_renewal') }}
          </a-button>
        </div>
      </li>
    </ul>
    <a-modal v-model="contactVisible"
             :title="$t('page_personal_contact_info')"
    >
      <template slot="footer">
        <a-button key="submit" type="primary" @click="()=>contactVisible=false">
          {{ $t('ok') }}
        </a-button>
      </template>
      <div class="content-p">
        <p>{{ $t('page_personal_contact_by_phone') }}</p>
        <div class="saleService_pop_content">
          <span>刘经理 <a>18052468101</a></span>
          <span>赵经理 <a>13306169546</a></span>
        </div>

        <p>{{$t('page_personal_contact_by_wechat')}}</p>
        <div class="saleService_pop_content">
          <div class="saleService_pop_img">
            <img src="~@/assets/images/lxf.png">
            <span>刘经理</span>
          </div>
          <div class="saleService_pop_img">
            <img src="~@/assets/images/zyz.png">
            <span>赵经理</span>
          </div>
        </div>
      </div>

    </a-modal>

  </div>
</template>

<script>
import { getLocalStorage } from "@/utils/storage";
import { MasterlinkTenantServiceProxy } from '@/service-proxies/app-v2/system.service-proxies.ts'

const mtsp = new MasterlinkTenantServiceProxy()
export default {
  name: 'TenantInfo',
  data () {
    return {
      tenantId: getLocalStorage("USER_INFO").tenant_id,
      contactVisible: false,
      info: {}
    }
  },
  computed: {
    expiredText () { // 剩余过期时间
      if (!this.info.expireTime) {
        return ''
      } else {
        let cur = new Date().getTime()
        let later = new Date(this.info.expireTime).getTime()
        let days = (later - cur) / (1000 * 60 * 60 * 24)
        return this.$t('page_personal_surplus').replace('{0}', Math.floor(days)) // 毫秒=>日
      }
    },
    code() {
      return this.info.classes === 4 ? this.$t('page_personal_tenant_number') : this.$t('page_ops_customer_tenant_number')
    },
    name() {
      return this.info.classes === 4 ? this.$t('page_personal_tenant_name') : this.$t('page_ops_customer_tenant_name')
    },
  },
  created () {
    if (this.tenantId) {
      this.getTenantInfo()
    }
  },
  methods: {
    async getTenantInfo () {
      let res = await mtsp.queryRole(this.tenantId)
      this.info = res.data
    }
  }
}
</script>

<style scoped lang="less">
  .setting {
    ul {
      padding-left: 0;

      li {
        height: 108px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        border-bottom: 1px solid #e8e8e8;
        padding: 16px 0;
        align-items: center;

        .info-item {
          /*width: 60%;*/
          font-weight: 700;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;

          .name {
            color: #169BD5;
            font-size: 20px;
          }

          .rule {
            color: #AAAAAA;
            font-size: 18px;
          }

          .time {
            color: #F59A23 !important;
          }
        }

        .action {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .time {
          color: #F59A23;
          font-size: 18px;
          font-weight: 700;
          margin-right: 24px;
        }
      }
    }
  }

  .content-p {
    p {
      text-align: center;
      margin-top: 24px;
      font-weight: 700;
      font-size: 16px;

      &:first-child {
        margin-top: 0;
      }
    }
  }

  /deep/ .saleService_pop_content {
    display: flex;
    /*flex-flow: column wrap;*/
    align-items: center;
    justify-content: space-between;

    span {
      display: inline-block;
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
    }

    .saleService_pop_img {
      width: 47%;
      display: flex;
      flex-flow: column wrap;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
      }
    }
  }
</style>
